import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";

const Login = ({ refreshUserState, sessionExpired, setSessionExpired }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // hook for navigation

    // Check for session expiration message
    useEffect(() => {
        const message = localStorage.getItem("loginMessage");
        if (message && sessionExpired) {
            setError(message);
            localStorage.removeItem("loginMessage");
            setSessionExpired(false);
        }
    }, [sessionExpired, setSessionExpired]);

    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent form refresh
        setError(""); // Clear any existing errors
        setLoading(true);

        try {
            const response = await axios.post(
                "https://asldemologinauth-a8b2fpbnhrgygsaj.canadacentral-01.azurewebsites.net/auth/login",
                { username, password }
            );

            if (response.data.success) {
                // store the token securely
                const token = response.data.token;
                localStorage.setItem("jwt", token);

                // decode token (to extract user info)
                const user = parseJwt(token); // helper function
                console.log("Logged in as:", user);

                // store user details in localStorage
                localStorage.setItem("user", JSON.stringify(user));

                // update app state
                refreshUserState();

                // redirect to the hub page
                navigate("/");
            } else {
                setError("Invalid username and/or password");
            }
        } catch (err) {
            setError("Invalid username and/or password.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // helper to decode the jwt
    const parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split(".")[1]));
        } catch (e) {
            console.error("Failed to parse JWT:", e);
            return null;
        }
    };

    return (
        <div className="login-container">
            <h2>Intersign Login Portal</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit" disabled={loading}>
                    {loading ? (
                        <>
                            <div className="loading-spinner">
                                <div className="spinner"></div>
                            </div>
                            Logging in...
                        </>
                    ) : (
                        "Log In"
                    )}
                </button>
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

export default Login;
